import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { Box, AppBar, Toolbar, Typography, Button } from '@mui/material'
import { useDispatch } from 'react-redux'
import { logout } from '../store/slices/authSlice'

const Layout = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch(logout())
    navigate('/login')
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Dailybuzzvibes
          </Typography>
          <Button color="inherit" onClick={() => navigate('/domains')}>
            Domains
          </Button>
          <Button color="inherit" onClick={() => navigate('/settings')}>
            Settings
          </Button>
          <Button color="inherit" onClick={handleLogout}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ mt: 4, mb: 4, flex: 1 }}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default Layout 